import "babel-polyfill";
import { createApp } from "vue";
import { setupStore } from "@/store";

import { setDirective } from "@/utils/directive/index";
import { postData } from "@/service/config";
import { setupSvgIcon } from "./components/svg";

import App from "./App.vue";
import router from "./router";

import "lib-flexible/flexible";
import "element-plus/lib/theme-chalk/index.css";
import "./utils/global";
import "./icons/iconfont.css";
import "./icons/iconfont.js";
import "./assets/main.scss";
import "./assets/element.scss";
import "./assets/tailwind.css";

const app = createApp(App);
setDirective(app);
setupStore(app);
setupSvgIcon(app);
app.config.globalProperties.postData = postData;

app.use(router);
app.mount("#app");
